export default __webpack_public_path__ + "static/media/earth.7821462f.png";